export function isEmpty(obj: any) {
  return (typeof obj === 'undefined') || obj === '' || obj === null;
}


